import React from 'react';
import superagent from 'superagent';

import { fromUnixTime, formatDistanceToNow, set, setDay, addHours, addDays, getUnixTime } from "date-fns";
import { formatInTimeZone } from 'date-fns-tz';

import {
    DateTimeInput
} from 'semantic-ui-calendar-react';

import MoviesTVWrapper from './MoviesTVWrapper.jsx';
import MediaCollection from './MediaCollection.jsx';
import CollectionEditor from './CollectionEditor.jsx';
import Messages from '../Util/Messages.jsx';

const TIMEZONE_LOS_ANGELES = "America/Los_Angeles";

import {
    Container,
    Segment,
    Grid,
    Header,
    Image,
    Icon,
    Button,
    Table,
    Form,
    Label,
    Message,
    Menu,
    Tab,
    Dropdown,
    Modal,
    Card, 
    Divider} from 'semantic-ui-react';

const PUBLISH_ACTION = true;

class CategoryEditor extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            category: null,
            currentCollection: null,
            selectedMediaProductId: null,
            isPublishModalOpen: false,
            customStartTime: null,
            customEndTime: null,
            entitlementClasses: [],
            isScheduled: false
        };
    }

    async componentDidMount() {
        await this.loadCategory(this.props.match.params);

        this.setState({ loading: true });

        const schemaRes = await superagent.get("/api/admin/media/schemas");
        const entitlementClasses = Object.keys(schemaRes.body.EntitlementClass).map(k => { return { "key": k, "value": k, "text": k } });
        const mediaTypes = Object.keys(schemaRes.body.MediaType).map(k => { return { "key": k, "value": k, "text": k } });
        this.setState({ schemas: schemaRes.body, entitlementClasses, mediaTypes });

        const mediaProductsRes = await superagent.get(`/api/admin/media/products`).accept('json');
        let mediaProductOptions = mediaProductsRes.body;
        if (this.state.category && this.state.category.entitlementClass) {
            mediaProductOptions = _.filter(mediaProductOptions, mediaProduct => mediaProduct.entitlementClass === this.state.category.entitlementClass);

            // Allow free media products
            const freeMediaProducts = _.filter(mediaProductsRes.body, mediaProduct => mediaProduct.entitlementClass === "FREE_FOR_ALL");
            mediaProductOptions = _.concat(mediaProductOptions, freeMediaProducts);
        }

        mediaProductOptions = mediaProductOptions.map(mediaProduct => {
            // Use unityPosterTexture because it is a smaller image.
            return { 
                "key": mediaProduct.id,
                "value": mediaProduct.id,
                "text": `(${mediaProduct.entitlementClass}) ${mediaProduct.title}`,
                "image": { src: mediaProduct.marketingData["en-US"].unityPosterTexture && mediaProduct.marketingData["en-US"].unityPosterTexture["src"] }
            }
        });
        this.setState({ loading: false, mediaProducts: mediaProductsRes.body, mediaProductOptions });
    }
    
    async onChange(e, { name, value }) {
        console.log(name, value);
        this.setState({ [name]: value});
    }

    async onIsScheduledChanged(e) {
        this.setState({ isScheduled: !this.state.isScheduled });
    }

    async onChangeUnityTextureConfig(e, { name, value }) {
        const category = this.state.category;
        if (!category.unityTextureConfig) {
            category.unityTextureConfig = {
                imageWidth: 173,
                imageHeight: 256,
                canvasWidth: 512,
                canvasHeight: 512
            }
        }
        category.unityTextureConfig[name] = parseInt(value);
        this.setState({ category });
    }
    
    async onChangeCategory(e, { name, value }) {
        console.log(name, value);
        const category = this.state.category;
        category[name] = value;
        this.setState({ category });
    }

    async onCreate() {
    
        try {
            const payload = {
                title: this.state.newCategoryTitle,
                entitlementClass: this.state.newCategoryEntitlementClass,
                description: this.state.newCategoryDescription,
                isScheduled: this.state.isScheduled
            };
            this.setState({ loading: true });
            const res = await superagent.post(`/api/admin/media/category`).send(payload);
            return this.loadCategory({ categoryId: res.body.id });
        } catch (e) {
            if (e.response.status === 401) {
                this.setState({
                    loading: false,
                    messages: [{ msg: e.response.body.message }]
                });
            } else if (e.response.status === 422) {
                this.setState({
                    loading: false,
                    messages: e.response.body
                });
            } else {
                this.setState({
                    loading: false,
                    messages: [{msg: "Login failed!"}]
                })
            }
        }
    }

    async loadCategory({ categoryId }) {
        if (categoryId) {
            this.setState({ loading: true });
            let res = await superagent.get(`/api/admin/media/category?id=${categoryId}`).accept('json');
            console.log(res.body);
            const category = res.body;
            this.setState({ loading: false, category });
        }
    }

    async onRebuild(e) {
        e.preventDefault();
        const res = await superagent.get(`/api/admin/media/rebuild/category/${this.state.category.id}`).accept('json');
        console.log(res.body);
    }

    createTimestamps({ hours, days }) {
        let lastTimestamp;
        if (this.state.category.collections.length > 0) {
            lastTimestamp = _.last(this.state.category.collections).endTimestamp._seconds;
        } else {
            // TODO: why are we doing this?
            lastTimestamp = getUnixTime(set(setDay(new Date(), 5), { hours: 15, minutes: 0, seconds: 0}));
        }

        this.setState({ loading: true });
        
        let startTimestamp = fromUnixTime(lastTimestamp);
        let endTimestamp = fromUnixTime(lastTimestamp);
        if (hours != null) {
            endTimestamp = addHours(endTimestamp, hours);
        } else if (days != null) {
            endTimestamp = addDays(endTimestamp, days);
        } else {
            endTimestamp = addDays(endTimestamp, 7);
        }

        return {
            startTimestamp, endTimestamp
        }
    }

    async onAddDefaultCollection(e) {
        e.preventDefault();
        const category = this.state.category;
        category.defaultCollectionIndex = 0;
        this.setState({ category });
        const timestamps = this.createTimestamps({ days: 1500 });
        return this.onAddCollection(e, timestamps);
    }

    async onAddMonthlyCollection(e) {
        e.preventDefault();
        const timestamps = this.createTimestamps({ days: 28 });
        return this.onAddCollection(e, timestamps);
    }

    async onAddWeeklyCollection(e) {
        e.preventDefault();
        const timestamps = this.createTimestamps({ days: 7 });
        return this.onAddCollection(e, timestamps);
    }

    async onAddDailyCollection(e) {
        e.preventDefault();
        const timestamps = this.createTimestamps({ days: 1 });
        return this.onAddCollection(e, timestamps);
    }

    async onAddHourlyCollection(e) {
        e.preventDefault();
        const timestamps = this.createTimestamps({ hours: 1 });
        return this.onAddCollection(e, timestamps);
    }

    async onAddCustomCollection(e) {
        if (this.state.customStartTime && this.state.customEndTime) {
            // HACK HACK HACK 
            const start = new Date(this.state.customStartTime);
            const end = new Date(this.state.customEndTime);
            console.log(end);
            if (start.isAfter(end)) {
                return false;
            }
            let startTimestamp = set(start, { seconds: 0, milliseconds: 0});
            let endTimestamp = set(end, { seconds: 0, milliseconds: 0});
            return this.onAddCollection(e, { startTimestamp, endTimestamp });
        } else {
            // TODO: error!
        }
    }

    async onAddCollection(e, {startTimestamp, endTimestamp}) {
        e.preventDefault();
        const payload = {
            name: `${this.state.category.title}`, // (${startTimestamp.format && startTimestamp.format("LL z")} to ${endTimestamp.format("LL z")})`,
            startTimestamp: getUnixTime(startTimestamp),
            endTimestamp: getUnixTime(endTimestamp)
        };
        const res = await superagent.post(`/api/admin/media/collection`).send(payload);
        const newCollection = res.body;

        // HACK HACK HACK
        //
        // Returned collection will not have any products attached!
        if (!newCollection.products) {
            newCollection.products = [];
        }
        const category = this.state.category;
        category.collections.push(newCollection);
        category.productCollectionIds.push(newCollection.id);
        this.setState({ category, loading: false });

        await this.updateCategory();
    }

    async onRemoveCollection(collectionIndex, e) {
        e.preventDefault();

        const collection = this.state.category.collections[collectionIndex];

        this.setState({ loading: true });
        try {
            const res = await superagent.del(`/api/admin/media/collection/${collection.id}`);
            const category = this.state.category;
            category.collections.splice(collectionIndex, 1);
            category.productCollectionIds.splice(collectionIndex, 1);
            this.setState({ category, loading: false });
            await this.updateCategory();
        } catch (e) {
            console.log("error!", e);
        }
    }

    onShowPublishModal(collectionIndex, pendingPublishAction, e) {
        e.preventDefault();
        this.setState({ selectedCollectionIndex: collectionIndex, pendingPublishAction, isPublishModalOpen: true } );
    }

    onClosePublishModal(e) {
        this.setState({ selectedCollectionIndex: -1, isPublishModalOpen: false } );
    }

    async onPublishCollection(e) {
        e.preventDefault();

        const { selectedCollectionIndex, category } = this.state;

        if (selectedCollectionIndex === -1) {
            return;
        }

        category.collections[selectedCollectionIndex].isPublished = true;
        this.setState({ loading: true, category });

        // Update the collection.
        await superagent.put(`/api/admin/media/collection`).send(category.collections[selectedCollectionIndex]);
        this.setState({ loading: false, category, isPublishModalOpen: false });
    }

    async onUnpublishCollection(e) {
        e.preventDefault();

        const { selectedCollectionIndex, category } = this.state;
        if (selectedCollectionIndex === -1) {
            return;
        }

        category.collections[selectedCollectionIndex].isPublished = false;
        this.setState({ loading: true, category });

        // Update the collection.
        await superagent.put(`/api/admin/media/collection`).send(category.collections[selectedCollectionIndex]);
        this.setState({ loading: false, category, isPublishModalOpen: false });
    }

    async updateCategory() {
        console.log(this.state.category);
        this.setState({ loading: true });
        await superagent.put(`/api/admin/media/category`).send(this.state.category);
        this.setState({ loading: false });
    }

    renderCollection(collection, collectionIndex) {
        
        // HACK HACK HACK
        //
        // These function also exist above in renderScheduledCollection()

        let onProductSelectionChanged = async (e, { name, value }) => {
            this.setState({selectedMediaProductId: value});
        };

        let onAddProductToCollection = async (e) => {
            e.preventDefault();
            if (this.state.selectedMediaProductId) {
                const mediaProduct = _.find(this.state.mediaProducts, ["id", this.state.selectedMediaProductId]);
                const category = this.state.category;

                category.collections[collectionIndex].mediaProductIds.push(this.state.selectedMediaProductId);
                category.collections[collectionIndex].products.push(mediaProduct);

                this.setState({ category, selectedMediaProductId: null });

                // Update the collection.
                await superagent.put(`/api/admin/media/collection`).send(category.collections[collectionIndex]);
            }
        };

        let onRemoveProductFromCollection = async (removedProductIndex) => {
            const category = this.state.category;

            category.collections[collectionIndex].mediaProductIds.splice(removedProductIndex, 1);
            category.collections[collectionIndex].products.splice(removedProductIndex, 1);

            this.setState({ category });

            // Update the collection.
            await superagent.put(`/api/admin/media/collection`).send(category.collections[collectionIndex]);
        }

        let onReorderProduct = async (productIndexA, productIndexB) => {
            console.log("Reordering Unscheduled Collection of Products ", productIndexA, productIndexB)
            const category = this.state.category;

            const movedProductId = category.collections[collectionIndex].mediaProductIds[productIndexB];
            category.collections[collectionIndex].mediaProductIds.splice(productIndexB, 1);
            category.collections[collectionIndex].mediaProductIds.splice(productIndexA, 0, movedProductId);

            const movedProduct = category.collections[collectionIndex].products[productIndexB];
            category.collections[collectionIndex].products.splice(productIndexB, 1);
            category.collections[collectionIndex].products.splice(productIndexA, 0, movedProduct);

            this.setState({ category });

            // Update the collection.
            await superagent.put(`/api/admin/media/collection`).send(category.collections[collectionIndex]);
        }

        return (
            <Segment key={collection.id} loading={this.state.loading}>
                <Header as="h2">{collection.name}</Header>

                <Form.Group>
                    <Dropdown search selection
                        placeholder="Type a media product name or choose an option..."
                        fluid
                        icon='search'
                        loading={this.state.mediaProductOptions === null}
                        size="small"
                        value={this.state.selectedMediaProductId}
                        name="mediaItemId"
                        closeOnChange
                        options={this.state.mediaProductOptions}
                        onChange={onProductSelectionChanged.bind(this)} />
                    <Button onClick={onAddProductToCollection.bind(this)}>Add product to collection</Button>
                </Form.Group>

                <MediaCollection collection={collection} onRemoveProduct={onRemoveProductFromCollection.bind(this)} onReorderProduct={onReorderProduct.bind(this)} />
            </Segment>
        );
    }

    async onCreateTopic(collection) {
        if (collection.products && collection.products.length > 0) {
            this.setState({loading: true});
            let from = "(n/a)";
            if (collection.startTimestamp) {
                if (collection.startTimestamp._seconds) {
                    from = formatInTimeZone(fromUnixTime(collection.startTimestamp._seconds), TIMEZONE_LOS_ANGELES, 'PPp z');
                } else {
                    from = formatInTimeZone(fromUnixTime(collection.startTimestamp), TIMEZONE_LOS_ANGELES, 'PPp z');
                }
            }

            const firstMediaProduct = collection.products[0];
            
            const topic = {
                name: `event_prototype_${collection.startTimestamp._seconds}_${firstMediaProduct.bigMediaId}`,
                title: `Prototype event for ${firstMediaProduct.title} on ${from}`,
                description: `Prototype event for ${firstMediaProduct.title} on ${from}`
            };

            try {
                await superagent.post(`/api/admin/topic`).send(topic);
                this.props.history.push({pathname: '/events/topics'});
                window.location.reload();
            } catch (e) {
                this.setState({loading: false});
            }
        }
    }

    renderScheduledCollection(collection, collectionIndex) {
        const from =    (collection.startTimestamp && collection.startTimestamp._seconds) ? formatInTimeZone(fromUnixTime(collection.startTimestamp._seconds), TIMEZONE_LOS_ANGELES, 'PPp z') : "Error";
        const to =      (collection.endTimestamp && collection.endTimestamp._seconds) ? formatInTimeZone(fromUnixTime(collection.endTimestamp._seconds), TIMEZONE_LOS_ANGELES, 'PPp z') : "Error";
        const createdAt = (collection.createdAt && collection.createdAt._seconds) ? formatInTimeZone(fromUnixTime(collection.createdAt._seconds), TIMEZONE_LOS_ANGELES, 'PPp z') : "Error";
        const dateRangeHeader = `From ${from} to ${to}`;

        // HACK HACK HACK
        //
        // These function also exist above in renderCollection()
        let onProductSelectionChanged = async (e, { name, value }) => {
            this.setState({selectedMediaProductId: value});
        };

        let onAddProductToCollection = async (e) => {
            e.preventDefault();
            if (this.state.selectedMediaProductId) {
                const mediaProduct = _.find(this.state.mediaProducts, ["id", this.state.selectedMediaProductId]);
                const category = this.state.category;

                category.collections[collectionIndex].mediaProductIds.push(this.state.selectedMediaProductId);
                category.collections[collectionIndex].products.push(mediaProduct);

                this.setState({ category, selectedMediaProductId: null });

                // Update the collection.
                await superagent.put(`/api/admin/media/collection`).send(category.collections[collectionIndex]);
            }
        };

        let onRemoveProductFromCollection = async (removedProductIndex) => {
            const category = this.state.category;

            category.collections[collectionIndex].mediaProductIds.splice(removedProductIndex, 1);
            category.collections[collectionIndex].products.splice(removedProductIndex, 1);

            this.setState({ category });

            // Update the collection.
            await superagent.put(`/api/admin/media/collection`).send(category.collections[collectionIndex]);
        }

        let publishingNote = collection.isPublished ?
            (
                <div>
                    <Message positive icon compact>
                        <Icon name="unhide" />
                        <Message.Content>
                            <Message.Header>This collection is published!</Message.Header>
                            It's visible to people on the Bigscreen app and website.
                        </Message.Content>
                    </Message>
                    <Button color="red" icon="hide" onClick={this.onShowPublishModal.bind(this, collectionIndex, false)} content="Unpublish" />
                </div>
            ) : (
                <div>
                    <Message warning icon compact>
                        <Icon name="hide" />
                        <Message.Content>
                            <Message.Header>This collection is NOT published.</Message.Header>
                            Publish the collection to allow people to see it in the Bigscreen app and website!<br />
                        </Message.Content>
                    </Message>
                    
                    {collection.mediaProductIds.length > 0 && <Button color="orange" icon="unhide" onClick={this.onShowPublishModal.bind(this, collectionIndex, true)} content="Publish Now!" />}
                </div>
            );

        return (
            <Segment key={collection.id} loading={this.state.loading}>
                <Header as="h3">{dateRangeHeader}
                    {!collection.isPublished && <Button floated="right" color="red" icon="trash" onClick={this.onRemoveCollection.bind(this, collectionIndex)} content="Delete Collection!" />}
                </Header>

                {publishingNote}

                <Table celled>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell width={2}>Name</Table.HeaderCell>
                            <Table.HeaderCell width={2}>Published?</Table.HeaderCell>
                            <Table.HeaderCell width={2}>Available From</Table.HeaderCell>
                            <Table.HeaderCell width={2}>Available Until</Table.HeaderCell>
                            <Table.HeaderCell width={1}>Created At</Table.HeaderCell>
                            <Table.HeaderCell width={1}>Topic</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        <Table.Row color="red">
                            <Table.Cell width={2}>
                                {collection.name}
                            </Table.Cell>
                            <Table.Cell width={2}>
                                {collection.isPublished ? <Label color="green">Published</Label> : <Label color="red">Not Published</Label>}
                            </Table.Cell>
                            <Table.Cell width={2}>
                                {from}
                            </Table.Cell>
                            <Table.Cell width={2}>
                                {to}
                            </Table.Cell>
                            <Table.Cell width={1}>
                                {createdAt}
                            </Table.Cell>
                            <Table.Cell width={1}>
                                <Button size="tiny" color="blue" onClick={this.onCreateTopic.bind(this, collection)}>Create Topic</Button>
                            </Table.Cell>
                        </Table.Row>
                    </Table.Body>
                </Table>

                {!collection.isPublished && <Form.Group>
                    <Dropdown search selection
                        placeholder="Type a media product name or choose an option..."
                        fluid
                        icon='search'
                        loading={this.state.mediaProductOptions === null}
                        size="small"
                        value={this.state.selectedMediaProductId}
                        name="mediaItemId"
                        closeOnChange
                        options={this.state.mediaProductOptions}
                        onChange={onProductSelectionChanged.bind(this)} />
                    <Button onClick={onAddProductToCollection.bind(this)}>Add product to collection</Button>
                </Form.Group>}

                <MediaCollection collection={collection} onRemoveProduct={onRemoveProductFromCollection.bind(this)} />
            </Segment>
        );
    }

    render() {
        if (this.state.category) {
            const categorySettings = (
                <div>
                    <Button fluid primary onClick={this.onRebuild.bind(this)}>Rebuild Unity Textures ⏰</Button>
                    <br />
                    <Form size='small' onSubmit={this.updateCategory.bind(this)}>                    
                        <Form.Group widths="equal">
                            <Form.Input label='Unique Category Name (read-only)' readOnly width="3" value={this.state.category.name} name="name" />
                            <Form.Button label="&nbsp;" size="tiny" primary onClick={(e) => { e.preventDefault(); this.setState({copyText: "Copied!"}); setTimeout(() => { this.setState({copyText: undefined})}, 2000); navigator.clipboard.writeText(this.state.category.name)}}>{this.state.copyText || "Copy 😮"}</Form.Button>
                        </Form.Group>

                        <Form.Group>
                            <Form.Input width="4" required label='Title' value={this.state.category.title} name="title" onChange={this.onChangeCategory.bind(this)} />
                        </Form.Group>

                        <Form.Group>
                            <Form.Input width="8" required label='Description' value={this.state.category.description} name="description" onChange={this.onChangeCategory.bind(this)} />
                        </Form.Group>

                        <Header as="h4">Unity Texture Settings</Header>
    
                        <Form.Group widths="equal">
                            <Form.Input required label='Image Width' value={this.state.category.unityTextureConfig.imageWidth} name="imageWidth" onChange={this.onChangeUnityTextureConfig.bind(this)} />
                            <Form.Input required label='Image Height' value={this.state.category.unityTextureConfig.imageHeight} name="imageHeight" onChange={this.onChangeUnityTextureConfig.bind(this)} />
                            <Form.Input required label='Canvas Width' value={this.state.category.unityTextureConfig.canvasWidth} name="canvasWidth" onChange={this.onChangeUnityTextureConfig.bind(this)} />
                            <Form.Input required label='Canvas Height' value={this.state.category.unityTextureConfig.canvasHeight} name="canvasHeight" onChange={this.onChangeUnityTextureConfig.bind(this)} />
                        </Form.Group>
                        <Form.Group><Button primary content='Save Settings' type='submit' /></Form.Group>
                    </Form>
                </div>
            );

            if (this.state.category.isScheduled) {
                let collections = ( <div /> );
                if (this.state.category && this.state.category.isScheduled) {
                    collections = (
                        <div>
                            {this.state.category.collections.map((collection, collectionIndex) => this.renderScheduledCollection(collection, collectionIndex))}
                        </div>
                    );
                }   

                return (
                    <MoviesTVWrapper title={`Category: ${this.state.category.title}`} loading={this.state.loading}>
                        
                        {categorySettings}
    
                        {this.state.pendingPublishAction === PUBLISH_ACTION ? (
                            <Modal dimmer="inverted" closeOnEscape={true} closeOnDimmerClick={true} closeIcon size='small' 
                                open={this.state.isPublishModalOpen}
                                onClose={this.onClosePublishModal.bind(this)}>
                                <Modal.Header>Publish this collection</Modal.Header>
                                <Modal.Content>
                                    <p>Are you sure you want to publish this collection and push it live onto Bigscreen?</p>
                                    <p>
                                        <strong>IMPORTANT #1: After this, you can no longer add products to this collection.</strong>
                                    </p>
                                    <p>
                                        <strong>IMPORTANT #2: Customers will be able to order items from this collection!</strong>
                                    </p>
                                </Modal.Content>
                                <Modal.Actions>
                                    <Button loading={this.state.loading}
                                        negative
                                        icon=''
                                        labelPosition='left'
                                        content='No'
                                    />
                                    <Button loading={this.state.loading}
                                    positive
                                    icon='checkmark'
                                    labelPosition='right'
                                    content='Yes' onClick={this.onPublishCollection.bind(this)}
                                    />
                                </Modal.Actions>
                            </Modal>
                        ) : (
                            <Modal dimmer="inverted" closeOnEscape={true} closeOnDimmerClick={true} closeIcon size='small' 
                                open={this.state.isPublishModalOpen}
                                onClose={this.onClosePublishModal.bind(this)}>
                                <Modal.Header>Unpublish this collection</Modal.Header>
                                <Modal.Content>
                                    <p>Are you sure you want to unpublish this collection and remove it from Bigscreen?</p>
                                    <p>
                                        <strong>CAREFUL: If this is permanent, customers who have ordered from this collection will no longer be able to access their movies.</strong>
                                    </p>
                                </Modal.Content>
                                <Modal.Actions>
                                    <Button loading={this.state.loading}
                                        negative
                                        icon=''
                                        labelPosition='left'
                                        content='No'
                                    />
                                    <Button loading={this.state.loading}
                                    negative
                                    icon='hide'
                                    labelPosition='right'
                                    content='Yes Unpublish This Collection' onClick={this.onUnpublishCollection.bind(this)}
                                    />
                                </Modal.Actions>
                            </Modal>
                        )}
                        
                        <Divider />

                        <Segment secondary>
                            <Form size='small'>
                            <Form.Group inline widths="3">
                            <DateTimeInput name="customStartTime"
                                autoComplete="off"
                                dateTimeFormat='LLLL'
                                timeFormat="AMPM"
                                clearable
                                closable
                                width={3}
                                inlineLabel
                                label="Start"
                                placeholder="Start Date/Time"
                                value={this.state.customStartTime}
                                iconPosition="left"
                                onChange={this.onChange.bind(this)} />
                            <DateTimeInput name="customEndTime"
                                autoComplete="off" 
                                dateTimeFormat='LLLL'
                                timeFormat="AMPM"
                                clearable
                                closable
                                width={3}
                                inlineLabel
                                label="End"
                                placeholder="End Time"
                                value={this.state.customEndTime}
                                iconPosition="left"
                                onChange={this.onChange.bind(this)} />
                            <Form.Button inline onClick={this.onAddCustomCollection.bind(this)}>Add Collection</Form.Button>
                            </Form.Group>
                            </Form>
                            <small>Timezone: {TIMEZONE_LOS_ANGELES} (PST/PDT)</small>
                        </Segment>
                        <Button onClick={this.onAddMonthlyCollection.bind(this)}>Add Another Month</Button>
                        <Button onClick={this.onAddWeeklyCollection.bind(this)}>Add Another Week</Button>
                        <Button onClick={this.onAddHourlyCollection.bind(this)}>QA-Add 1 Hour Collection</Button>
                        <Button onClick={this.onAddDailyCollection.bind(this)}>QA-Add 1 Day Collection</Button>
                        <Header as="h2">Collections</Header>
                        {collections}
                    </MoviesTVWrapper>
                );
            } else {
                const defaultCollection = (this.state.category.defaultCollectionIndex >= 0
                    && this.state.category.defaultCollectionIndex < this.state.category.collections.length) ?
                    this.state.category.collections[this.state.category.defaultCollectionIndex] : null;
                return (
                    <MoviesTVWrapper title={`Category: ${this.state.category.title}`} loading={this.state.loading}>
                        {categorySettings}
                        
                        <Divider />
    
                        {defaultCollection ? this.renderCollection(defaultCollection, this.state.category.defaultCollectionIndex) : 
                        <Button onClick={this.onAddDefaultCollection.bind(this)}>Add Default Collection</Button>}
                    </MoviesTVWrapper>
                );
            }
        } else {
            return (
                <MoviesTVWrapper title="Create a category" loading={this.state.loading}>
                    <Messages className="inverted" messages={this.state.messages} />

                    <Form size='small' onSubmit={this.onCreate.bind(this)}>
                        <Form.Group widths="equal">
                            <Form.Input required label='Title' value={this.state.newCategoryTitle} name="newCategoryTitle" onChange={this.onChange.bind(this)} />
                        </Form.Group>

                        <Form.Group widths="equal">
                            <Form.Input required label='Description' value={this.state.newCategoryDescription} name="newCategoryDescription" onChange={this.onChange.bind(this)} />
                        </Form.Group>

                        <Form.Group>
                            <Form.Select readOnly={this.state.category !== null}
                                required
                                width={3}
                                size="tiny"
                                label='Entitlement Class'
                                name="newCategoryEntitlementClass"
                                value={this.state.newCategoryEntitlementClass}
                                options={this.state.entitlementClasses}
                                onChange={this.onChange.bind(this)}
                            />
                        </Form.Group>

                        <Form.Group widths="equal">
                            <Form.Checkbox label="Scheduled category (e.g. movie nights)" checked={this.state.isScheduled} name="isScheduled" onChange={this.onIsScheduledChanged.bind(this)} />
                        </Form.Group>

                        <Form.Group><Button primary content='Create Category' type='submit' /></Form.Group>
                    </Form>
                </MoviesTVWrapper>
            );
        }
    }
}

export default CategoryEditor;
